import { render, staticRenderFns } from "./ExceptionCountsByMonthChart.vue?vue&type=template&id=5b032626&"
import script from "./ExceptionCountsByMonthChart.vue?vue&type=script&lang=js&"
export * from "./ExceptionCountsByMonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports